import React, { Fragment, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  Chip,
  makeStyles,
  colors
} from '@material-ui/core';

import NavItem from './NavItem';

import { RiAlarmWarningLine } from "react-icons/ri";
import { IoIosCalculator } from "react-icons/io";
import { BsBuilding } from "react-icons/bs";
import { AiOutlineFileProtect } from "react-icons/ai";
import { IoMdCart } from "react-icons/io";
import { MdManageAccounts } from "react-icons/md";
import { Activity } from 'react-feather';
import { GiHandTruck } from "react-icons/gi";
import { BsPrinter } from "react-icons/bs";
import { AiFillTool } from "react-icons/ai";
import { GoTools } from 'react-icons/go';
import { BsCurrencyExchange } from "react-icons/bs";
import { FaClipboardList } from "react-icons/fa";
import { FaFileImport } from "react-icons/fa";

const items = [
  {
    href: '/mgt/occurrences',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/units',
    icon: BsBuilding,
    title: 'Unidades',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/contracts',
    icon: AiOutlineFileProtect,
    title: 'Contratos',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/productslpu',
    icon: FaClipboardList,
    title: 'LPU',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/stocks',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/reports',
    icon: BsPrinter,
    title: 'Relatórios',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/imports',
    icon: FaFileImport,
    title: 'Importação',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/fin/main',
    icon: BsCurrencyExchange,
    title: 'Financeiro',
    color: colors.green[600],
    profile: 'ADM'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/occurrences',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/stocks',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/units',
    icon: BsBuilding,
    title: 'Unidades',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/contracts',
    icon: AiOutlineFileProtect,
    title: 'Contratos',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/reports',
    icon: BsPrinter,
    title: 'Relatórios',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/sup/main',
    icon: AiFillTool,
    title: 'Assistência Técnica',
    color: colors.orange[400],
    profile: 'AAD'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mgt/occurrences',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/budgets',
    icon: IoIosCalculator,
    title: 'Orçamentos',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/units',
    icon: BsBuilding,
    title: 'Unidades',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/contracts',
    icon: AiOutlineFileProtect,
    title: 'Contratos',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/products',
    icon: IoMdCart,
    title: 'Produtos',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/productslpu',
    icon: FaClipboardList,
    title: 'LPU',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/stocks',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/others',
    icon: GoTools,
    title: 'Configurações',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/reports',
    icon: BsPrinter,
    title: 'Relatórios',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/imports',
    icon: FaFileImport,
    title: 'Importação',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/fin/main',
    icon: BsCurrencyExchange,
    title: 'Financeiro',
    color: colors.green[600],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {

  const classes = useStyles();

  const [user, setUser] = useState({
    avatar: localStorage.getItem('avatar'),
    firstname: localStorage.getItem('firstname'),
    lastname: localStorage.getItem('lastname'),
    company: localStorage.getItem('company'),
    profile: localStorage.getItem('profile')
  });

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
      setUser(localStorage.getItem('user'));
    }
  }, []);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >

      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={1}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          variant="circle"
          src={`/static/images/avatars/`}
          to="/mgt/main"
        />
        <Typography
          className={classes.name}
          color="textPrimary"
          variant="body2"
        >
          {user.firstname} {user.lastname}
        </Typography>
        <Chip
          variant="default"
          size="small"
          label={`Perfil de acesso é ` + user.profile + `.`}
        />
      </Box>
      <Divider />
      <Box p={1}>
        <List>
          {items.map((item) => (
            (item.profile == localStorage.getItem('profile')) ? (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                color={item.color}
              />) : ('')
          ))}
        </List>
      </Box>
      <Box flexGrow={1} hidden />
      <Box
        hidden
        p={1}
        m={1}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Sair da Área de Manutenção?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Aqui Você Entra na Área de Administração do Sistema
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={1}
        >
          <Button
            color="secondary"
            component="a"
            href="/adm/main"
            variant="contained">
            Administração
          </Button>
        </Box>
      </Box>

    </Box>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {(localStorage.getItem('profile') === 'MON' || localStorage.getItem('profile') === 'MAN' || localStorage.getItem('profile') === 'AST') ? (
            <div></div>
          ) : (
            content
          )}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {(localStorage.getItem('profile') === 'MON' || localStorage.getItem('profile') === 'MAN' || localStorage.getItem('profile') === 'AST') ? (
            <div></div>
          ) : (
            content
          )}
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default NavBar;
